<template>
  <div class="layout" id="history">
    <h2>台灣樂團發展大事件</h2>
    <div class="pc">
      <div class="tab pc">
        <div class="tablist active">
          <p class="tabyear" id="year1">1950s</p>
          <p class="tabtitle" id="title1">西洋文化擴散</p>
        </div>
        <div class="tablist2">
          <p class="tabyear">1980s</p>
          <p class="tabtitle">熱門音樂發跡</p>
        </div>
        <div class="tablist3">
          <p class="tabyear"> 1990s</p>
          <p class="tabtitle">地下樂團崛起</p>
        </div>
        <div class="tablist4">
          <p class="tabyear">2000s</p>
          <p class="tabtitle">樂團的世代來臨</p>
        </div>
        <div class="tablist5">
          <p class="tabyear">2020s</p>
          <p class="tabtitle">獨立音樂遍地開花</p>
        </div>
      </div>

    </div>
    <section class="section pc">
      <div class="section_left pc">
        <img id="pictest1" src="https://www.ftvnews.com.tw/topics/taiwanband/img/1950.jpg" alt="1950">
        <img id="pictest2" style="display:none" src="https://www.ftvnews.com.tw/topics/taiwanband/img/1980.jpg"
          alt="1980">
        <img id="pictest3" style="display:none" src="https://www.ftvnews.com.tw/topics/taiwanband/img/1990.jpg"
          alt="1990">
        <img id="pictest4" style="display:none" src="https://www.ftvnews.com.tw/topics/taiwanband/img/2000.jpg"
          alt="2000">
        <img id="pictest5" style="display:none" src="https://www.ftvnews.com.tw/topics/taiwanband/img/2020.jpg"
          alt="2020">
      </div>
      <div class="section_right pc">
        <div id="test1">
          <p class="title">西洋文化擴散</p>
          <p>
            美國駐軍協防台灣時期，大大影響台灣娛樂文化的發展。<br>
            電台放送西洋音樂，給予新穎的聽覺刺激；而美軍俱樂部帶動LIVE表演，台灣樂團也開始於Pub、西餐廳翻唱cover西洋歌曲，「雷蒙」、「陽光」等樂團也為後代的傳承留下契機。
          </p>
          <p class="title">熱門的誕生</p>
          <p>
            「熱門音樂」一詞的誕生，源於1957年的《皇冠歌選 Hit Song》，當時第五期命名為「熱門音樂特輯」，搭配電台節目的放送，讓西洋音樂蔚為流行，「熱門音樂」名號因而深植樂迷的內心。
          </p>
        </div>
        <div id="test2" style="display:none">
          <p class="title">熱門音樂發跡</p>
          <p>
            隨著美軍來台的熱門音樂風潮，從最初翻唱西洋歌曲，後來也開始有樂團創作自己的歌。在當時唱片公司以凸顯主唱為軸，像是薛岳的幻眼合唱團、娃娃的丘丘合唱團等，這些充滿樂團元素的歌曲，著實鼓舞了搖滾樂的發展。
          </p>
          <p class="title">為何以前叫做合唱團？</p>
          <p>
            經歷過錄音帶、CD時代的樂迷，可能曾在唱片側標看過「合唱團」的用詞，如紅十字合唱團、紅螞蟻合唱團；這是因為早期大眾還沒有「樂團」的概念，唱片公司因而用「合唱團」的稱謂作為這些音樂團體的稱呼。
          </p>
        </div>
        <div id="test3" style="display:none">
          <p class="title">地下樂團崛起</p>
          <p>
            1980年代末端正值台灣解嚴之時，各種風格、題材的創作能量如火山爆發，更出現了對於主流的反動之聲，開始有人士自行開創唱片品牌，挖鑿具本土意識的音樂，甚至漸漸帶動商業市場重視「非主流」音樂，催生一片地下樂團氣息。
          </p>
          <p class="title">推動非主流的功臣－水晶唱片</p>
          <p>
            1986年成立的「水晶唱片」，提攜各種另類曲風，實驗性樂團「黑名單工作室」立下標竿，帶動非主流文化的推廣。「友善的狗」廠牌1994年發行《台灣地下音樂檔案》，收錄刺客、濁水溪公社等樂團，地下音樂儼然成為時代象徵。
          </p>
        </div>
        <div id="test4" style="display:none">
          <p class="title">樂團的世代來臨</p>
          <p>2000年的金曲獎台上，亂彈奪下「最佳演唱團體」，主唱亂彈阿翔在台上高呼「樂團的時代來臨了！」成為搖滾箴言。
            後來接續五月天在市場上的成功，樂團圈顯得生機勃勃，儼然成為地下竄出地上的表徵。
          </p>
          <p class="title">千禧樂團潮的發展</p>
          <p>2000年前後，樂團曾是唱片產業的熱潮，原為地下發跡的「伍佰&China Blue」，更激勵了許多人組團的夢想。
            但日後有些主流公司簽下的樂團，並沒獲得相對應的市場回報，不少樂團重回自立自強的方式實踐音樂理念，倡議「獨立」精神。
          </p>
          <p class="title">樂團的影響力</p>
          <p>2014年太陽花學運，滅火器以〈島嶼天光〉發聲，帶動年輕人關心政治。2017年金曲獎，草東沒有派對橫掃6項大獎，撼動流行樂壇。
            樂團的聲音，象徵人們無窮的創造力，更造就不可忽視的現象。這條音樂軌跡，相信永遠未完待續。
          </p>
        </div>
        <div id="test5" style="display:none">
          <p class="title">獨立音樂遍地開花</p>
          <p>
            時至今日，越來越多元的音樂風格出現，LiveHouse的演出種類眾多，音樂廠牌、音樂祭等也遍地開花，現在更有樂迷以「聽團仔」、「看團仔」稱謂自居，成為了越來越多年輕人間的風氣。
          </p>
        </div>
      </div>
    </section>
    <div class="mb_section">
      <div class="mb_tab">
        <div class="mb_card">
          <p class="mb_title">1950s 西洋文化擴散</p>
          <p class="mb_content">
            美國駐軍協防台灣時期，大大影響台灣娛樂文化的發展。
            電台放送西洋音樂，給予新穎的聽覺刺激；而美軍俱樂部帶動LIVE表演，台灣樂團也開始於Pub、西餐廳翻唱cover西洋歌曲，「雷蒙」、「陽光」等樂團也為後代的傳承留下契機。
          </p>
          <p class="mb_title">熱門的誕生</p>
          <p class="mb_content">
            「熱門音樂」一詞的誕生，源於1957年的《皇冠歌選 Hit Song》，當時第五期命名為「熱門音樂特輯」，搭配電台節目的放送，讓西洋音樂蔚為流行，「熱門音樂」名號因而深植樂迷的內心。
          </p>
        </div>
        <div class="mb_card">
          <p class="mb_title">1980s熱門音樂發跡</p>
          <p class="mb_content">
            隨著美軍來台的熱門音樂風潮，從最初翻唱西洋歌曲，後來也開始有樂團創作自己的歌。在當時唱片公司以凸顯主唱為軸，像是薛岳的幻眼合唱團、娃娃的丘丘合唱團等，這些充滿樂團元素的歌曲，著實鼓舞了搖滾樂的發展。
          </p>
          <p class="mb_title">為何以前叫做合唱團？</p>
          <p class="mb_content">
            經歷過錄音帶、CD時代的樂迷，可能曾在唱片側標看過「合唱團」的用詞，如紅十字合唱團、紅螞蟻合唱團；這是因為早期大眾還沒有「樂團」的概念，唱片公司因而用「合唱團」的稱謂作為這些音樂團體的稱呼。
          </p>
        </div>
        <div class="mb_card">
          <p class="mb_title">1990s地下樂團崛起</p>
          <p class="mb_content">
            1980年代末端正值台灣解嚴之時，各種風格、題材的創作能量如火山爆發，更出現了對於主流的反動之聲，開始有人士自行開創唱片品牌，挖鑿具本土意識的音樂，甚至漸漸帶動商業市場重視「非主流」音樂，催生一片地下樂團氣息。
          </p>
          <p class="mb_title">推動非主流的功臣－水晶唱片</p>
          <p class="mb_content">
            1986年成立的「水晶唱片」，提攜各種另類曲風，實驗性樂團「黑名單工作室」立下標竿，帶動非主流文化的推廣。「友善的狗」廠牌1994年發行《台灣地下音樂檔案》，收錄刺客、濁水溪公社等樂團，地下音樂儼然成為時代象徵。
          </p>
        </div>
        <div class="mb_card">
          <p class="mb_title">2000s樂團的世代來臨</p>
          <p class="mb_content">
            2000年的金曲獎台上，亂彈奪下「最佳演唱團體」，主唱亂彈阿翔在台上高呼「樂團的時代來臨了！」成為搖滾箴言。
            後來接續五月天在市場上的成功，樂團圈顯得生機勃勃，儼然成為地下竄出地上的表徵。
          </p>
          <p class="mb_title">千禧樂團潮的發展</p>
          <p class="mb_content">
            2000年前後，樂團曾是唱片產業的熱潮，原為地下發跡的「伍佰&China Blue」，更激勵了許多人組團的夢想。
            但日後有些主流公司簽下的樂團，並沒獲得相對應的市場回報，不少樂團重回自立自強的方式實踐音樂理念，倡議「獨立」精神。
          </p>
        </div>
        <div class="mb_card">
          <p class="mb_title">2020s獨立音樂遍地開花</p>
          <p class="mb_content">
            時至今日，越來越多元的音樂風格出現，LiveHouse的演出種類眾多，音樂廠牌、音樂祭等也遍地開花，現在更有樂迷以「聽團仔」、「看團仔」稱謂自居，成為了越來越多年輕人間的風氣。
          </p>
          <p class="mb_title">樂團的影響力</p>
          <p class="mb_content">
            2014年太陽花學運，滅火器以〈島嶼天光〉發聲，帶動年輕人關心政治。2017年金曲獎，草東沒有派對橫掃6項大獎，撼動流行樂壇。
            樂團的聲音，象徵人們無窮的創造力，更造就不可忽視的現象。這條音樂軌跡，相信永遠未完待續。
          </p>
        </div>
      </div>
    </div>
    <button id="question">
      <a href="https://www.ftvnews.com.tw/news/detail/2023330W0337" target="blank">一覽完整樂團史</a></button>
  </div>
</template>

<script>


/*eslint-disable*/
$(document).ready(function () {
  $('.tablist').click(function (e) {
    e.stopPropagation();
    if ($('#test1,#pictest1').fadeIn(300)) {
      ($('#test2,#test3,#test4,#test5,#pictest2,#pictest3,#pictest4,#pictest5').hide())
    }
  })
  $('.tablist2').click(function (e) {
    e.stopPropagation();
    if ($('#test2,#pictest2').fadeIn(300)) {
      ($('#test1,#test3,#test4,#test5,#pictest1,#pictest3,#pictest4,#pictest5').hide())
    }
  })
  $('.tablist3').click(function (e) {
    e.stopPropagation();
    if ($('#test3,#pictest3').fadeIn(300)) {
      ($('#test1,#test2,#test4,#test5,#pictest2,#pictest1,#pictest4,#pictest5').hide())
    }
  })
  $('.tablist4').click(function (e) {
    e.stopPropagation();
    if ($('#test4,#pictest4').fadeIn(300)) {
      ($('#test2,#test3,#test1,#test5,#pictest2,#pictest3,#pictest1,#pictest5').hide())
    }
  })
  $('.tablist5').click(function (e) {
    e.stopPropagation();
    if ($('#test5,#pictest5').fadeIn(300)) {
      ($('#test2,#test3,#test4,#test1,#pictest2,#pictest3,#pictest4,#pictest1').hide())
    }
  })
  $(".tablist").click(function () {
    $(".tablist").addClass("active");
    $(".tablist2, .tablist3, .tablist4, .tablist5").removeClass("active");
  });
  $(".tablist2").click(function () {
    $(".tablist2").addClass("active");
    $(".tablist, .tablist3, .tablist4, .tablist5").removeClass("active");
  });
  $(".tablist3").click(function () {
    $(".tablist3").addClass("active");
    $(".tablist, .tablist2, .tablist4, .tablist5").removeClass("active");
  });
  $(".tablist4").click(function () {
    $(".tablist4").addClass("active");
    $(".tablist, .tablist2, .tablist3, .tablist5").removeClass("active");
  });
  $(".tablist5").click(function () {
    $(".tablist5").addClass("active");
    $(".tablist, .tablist2, .tablist3, .tablist4").removeClass("active");
  });
});




export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }, methods: {

  },
}
</script>


<style scoped>
.section {
  margin: 1rem 0;
  display: grid;
  grid-template-columns: 1fr 2fr;
  border-left: 2px solid black;
  border-right: 2px solid black;
}

@media screen and (max-width:768px) {
  .section {
    grid-template-columns: 1fr;
  }
}

.section_right {
  margin: auto 2rem;
  align-items: center;
}

.section_left {
  padding: 1rem;
  padding-left: 2rem;
}

.section img {
  border-radius: 30px;
  width: 100%;
  margin: 2rem auto
}


.tab {
  display: flex;
  justify-content: space-around;
}

.tabyear {
  font-weight: 600;
  font-size: 40px;
  line-height: 52px;
  display: flex;
  align-items: flex-end;
  text-align: center;
  letter-spacing: 0.1em;
  color: black;
}

.tabyear:hover {
  color: #FBB91C;
}

.active {
  color: #FBB91C;
}




.active p {
  color: #FBB91C;
}

.active .tabyear::after {
  content: url('../assets/downhover.png');
}




.mb_content:hover {
  filter: drop-shadow(0px 0px 10px rgba(255, 180, 0, 0.7));
}



.tabyear::after {
  margin-left: .5rem;
  content: url('../assets/arrow.png');
}

.tabyear:hover::after {
  content: url('../assets/downhover.png');
}



.tabtitle {
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0.15em;
  margin-top: -2rem;
}

.title {
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.15em;
  margin-bottom: .5rem;
  font-weight: 600
}

.title:before {
  margin-right: .5rem;
  position: relative;
  top: 4px;
  content: url(../assets/star.png);
}


.mb_section {
  display: none;
}

.section_right:hover {
  filter: drop-shadow(0px 0px 80px rgba(247, 175, 9, 0.9));
  transition: all .5s;
}


@media screen and (max-width:768px) {
  .mb_section {
    display: block;
    overflow-x: scroll;
  }

  .mb_tab {
    display: flex;
    width: fit-content;
  }


  .mb_card {
    margin: .5rem;
    padding: 20px;
    width: 270px;
    border-radius: 30px;
  }


  .mb_card:nth-child(1) {
    background: linear-gradient(180deg, rgba(0, 0, 0, .4) 27.55%, rgba(0, 0, 0, 0.8) 70.78%), url(https://www.ftvnews.com.tw/topics/taiwanband/img/1950.jpg);
  }

  .mb_card:nth-child(2) {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 27.55%, rgba(0, 0, 0, 0.8)70.78%), url(https://www.ftvnews.com.tw/topics/taiwanband/img/1980.jpg);
  }

  .mb_card:nth-child(3) {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 27.55%, rgba(0, 0, 0, 0.8) 70.78%), url(https://www.ftvnews.com.tw/topics/taiwanband/img/1990.jpg);
  }

  .mb_card:nth-child(4) {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 27.55%, rgba(0, 0, 0, 0.8) 70.78%), url(https://www.ftvnews.com.tw/topics/taiwanband/img/2000.jpg);
  }

  .mb_card:nth-child(5) {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 27.55%, rgba(0, 0, 0, 0.8)70.78%), url(https://www.ftvnews.com.tw/topics/taiwanband/img/2020.jpg);
  }


  .mb_title {
    font-weight: bold;
    padding: .3rem 1rem;
    width: fit-content;
    background: #FBB91C;
    border: 1px solid #000000;
    border-radius: 30px;
  }


  .mb_content {
    color: white;
    font-size: 1rem;
    line-height: 25px;
    margin-top: 1rem;
    display: flex;
    align-items: flex-end;
    text-align: justify;
    letter-spacing: 0.05em;
  }

  .mb_content:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 180, 0, 0.7));
  }


}</style>
